import { Phone, FileText, CheckCircle } from "lucide-react";

const steps = [
  {
    icon: Phone,
    title: "Vous appelez ou vous passez",
    desc: "Un appel, ou un message WhatsApp avec des photos des dégâts. Nous venons chercher la voiture partout dans le canton de Genève.",
  },
  {
    icon: FileText,
    title: "Devis et assurance",
    desc: "Devis détaillé sous 24 h, envoyé avec les photos à votre assureur. Réparation en 2 à 3 jours ouvrables une fois l'accord et les pièces reçus.",
  },
  {
    icon: CheckCircle,
    title: "Restitution",
    desc: "Contrôle final, puis on vous rend la voiture là où on l'a prise. Vous ne réglez que la franchise.",
  },
];

const ProcessSection = () => (
  <section id="processus" className="py-24 relative">
    <div className="container mx-auto px-4">
      <div className="mb-12 max-w-2xl">
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-4">Comment ça se passe</h2>
        <p className="text-muted-foreground">De l'appel à la restitution, nous nous occupons de tout.</p>
      </div>

      <ol className="grid gap-6 md:grid-cols-3">
        {steps.map((step) => (
          <li key={step.title} className="border-t-2 border-primary pt-5">
            <step.icon className="w-5 h-5 text-primary mb-4" aria-hidden />
            <h3 className="font-semibold text-lg mb-2 tracking-tight">{step.title}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">{step.desc}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default ProcessSection;
